import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router';
import { Button } from '../shared/ui/button';
import { EmptyState } from '../shared/ui/empty-state';
import { LoadingState } from '../shared/ui/loading-state';
import { isChunkLoadError, recoverFromChunkError } from './chunk-reload';

export const RouteErrorElement = () => {
  const { t } = useTranslation();
  const error = useRouteError();
  const chunkError = isChunkLoadError(error);
  const [recovering, setRecovering] = useState(chunkError);
  const attempted = useRef(false);

  useEffect(() => {
    if (!chunkError || attempted.current) return;
    attempted.current = true;
    setRecovering(recoverFromChunkError(error));
  }, [chunkError, error]);

  if (recovering) return <LoadingState rows={4} />;

  return (
    <div role="alert">
      <EmptyState
        title={t('common.error')}
        action={
          <Button
            type="button"
            onClick={() => {
              window.location.reload();
            }}
          >
            {t('common.retry')}
          </Button>
        }
      />
    </div>
  );
};
